import React, {useEffect, useRef} from 'react';
import {whichDevice} from '@ruhnn/common/common/util.device';
// eslint-disable-next-line import/no-unresolved
import LaunchAppBtn from 'components/LaunchApp';
import './style.less';
import icon from './images/icon.png';
import card from './images/card.png';
import wallet from './images/wallet.png';
import home from './images/home.png';
import page from './images/page.png';

const {isWX, ios, mobile} = whichDevice();
const isMobileNotWeixin = !isWX && mobile;

function LaunchApp({onFail}) {
    const {search} = window.location;
    const appLink = `koc://m.koc18.com/izc${search}`;
    // koc://m.koc18.com/izc?path=/pages/xxx&query=${encode(query)}

    useEffect(() => {
        // 浏览器打开 唤起APP
        if (isMobileNotWeixin) {
            window.location.href = appLink;
        }
    }, []);

    return isWX ? (
        <button
            type="button"
            style={{
                width: 240,
                lineHeight: '44px',
                textAlign: 'center',
                fontSize: 15,
                display: 'block',
                margin: '0 auto',
                border: 'none',
                borderRadius: 100,
                backgroundColor: '#7F5DFF',
                color: '#ffffff',
                position: 'absolute',
                bottom: 128,
                left: 0,
                right: 0,
            }}
        >
            <LaunchAppBtn
                extinfo={search.replace('?', '')}
                wrapperStyle={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    opacity: 0,
                    left: 0,
                    top: 0,
                }}
                btnStyle={{
                    width: '240px',
                    height: '44px',
                    display: 'block',
                }}
                onFail={onFail}
            />
            打开APP
        </button>
    ) : (
        <div className="dfc poa" style={{bottom: 128, left: 0, right: 0}}>
            <a className="jump-app" href={appLink}>
                跳转APP
            </a>
        </div>
    );
}

function Download({onClick}) {
    return (
        <div className="dfc poa" style={{bottom: 60, left: 0, right: 0}}>
            <a
                onClick={onClick}
                className="download"
                href={
                    ios
                        ? 'https://apps.apple.com/cn/app/%E7%88%B1%E7%A7%8D%E8%8D%89-%E8%BE%BE%E4%BA%BA%E7%9C%9F%E5%AE%9E%E5%88%86%E4%BA%AB%E9%80%9A%E5%91%8A%E5%B9%B3%E5%8F%B0/id1643813247'
                        : 'https://ruhnn-web.oss-cn-hangzhou.aliyuncs.com/Android/koc_release_apk/ruhnn_koc_release.apk'
                }
            >
                下载APP
            </a>
        </div>
    );
}

const App = () => {
    const tooltipRef = useRef();

    const handleClick = () => {
        const dom = tooltipRef.current;
        if (!isWX || !dom) return;
        dom.style.display = 'block';
    };

    return (
        <div className="wrapper">
            <div className="tooltip" ref={tooltipRef}>
                <div className="arrow" />
                <div className="tooltip-content">前往浏览器打开</div>
            </div>
            <div className="head-bg" />
            <div className="icon-wrapper">
                <img src={icon} alt="" />
            </div>
            <div className="mt10 desc">
                真体验真分享。一站式报名，合作丝滑，提现秒到账，来爱种草即刻影响力变现！
            </div>
            <div className="desc-line">
                <div>
                    <img src={card} alt="" />
                </div>
                <div>
                    <div className="line-first">平台名片</div>
                    <div className="line-second">关联达人多平台账号，让品牌看到你的影响力</div>
                </div>
            </div>
            <div className="desc-line">
                <div>
                    <img src={home} alt="" />
                </div>
                <div>
                    <div className="line-first">商单广场</div>
                    <div className="line-second">涵盖多平台全类目，快速筛选精准匹配</div>
                </div>
            </div>
            <div className="desc-line">
                <div>
                    <img src={page} alt="" />
                </div>
                <div>
                    <div className="line-first">我的合作</div>
                    <div className="line-second">一站式管理合作商单，合作进度一目了然</div>
                </div>
            </div>
            <div className="desc-line">
                <div>
                    <img src={wallet} alt="" />
                </div>
                <div>
                    <div className="line-first">达人钱包</div>
                    <div className="line-second">资金变动清晰可追溯，一键提现快速到账</div>
                </div>
            </div>
            <LaunchApp onFail={handleClick} />
            <Download onClick={handleClick} />
            <div className="beian">
                <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn/">
                    浙公网安备33010202005173号 浙ICP备2025202982号-5
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn/">
                    Copyright&nbsp;©2012-{new Date().getFullYear()}
                    &nbsp;杭州爱种草科技有限公司
                </a>
            </div>
        </div>
    );
};

export default App;
